<template>
  <div class="a-tooltip" ref="tooltipRef">
    <div class="a-tooltip__content w6" :class="{ show: open, tooltipLeft: isLeft, tooltipRight: isRight }" ref="aboveTooltipRef">
      {{ message }}
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
import { defineExpose, ref, reactive } from 'vue';

const props = defineProps({
  title: {
    type: String,
    require: false,
    default: '',
    description: 'content of tooltip',
  },
  isEstateDetail: {
    type: Boolean,
    require: false,
    default: false,
    description: 'flag',
  }
});

const open = ref(false);
const message = ref('');
const tooltipRef = ref('');
const aboveTooltipRef = ref('');
const widthSp = 375;
const widthScreen = window.innerWidth;
const isLeft = ref(false);
const isRight = ref(false);

const show = (msg = null) => {
  const { x, right } = tooltipRef.value.getBoundingClientRect();
  if (props.isEstateDetail) {
    if (widthScreen <= 375) {
      if (x < 375 / 2) {
        aboveTooltipRef.value.style.left = 0;
        isRight.value = false;
        isLeft.value = true;
      } else {
        aboveTooltipRef.value.style.left = "-111px";
        isLeft.value = false;
        isRight.value = true;
      }
    }
  }
  if (msg) {
    message.value = msg ?? props.title;
  }
  open.value = true;
  setTimeout(() => {
    open.value = false;
  }, 3000);
};

defineExpose({ show });

</script>
